import type { CompanyContact } from '@tandemone/types'

import { SUPPLIER_CONTACT_ROLE_LABELS } from '@/domains/supplier-onboarding'

import { ProfileEmpty } from './profile-empty'
import { ProfileSection } from './profile-section'

export function ProfileContacts({
  companyName,
  rows
}: {
  companyName: string
  rows: CompanyContact[]
}) {
  return (
    <ProfileSection title={`${companyName} Business Contacts`}>
      {rows.length === 0 ? (
        <ProfileEmpty message='No business contacts listed.' />
      ) : (
        <ul className='divide-y divide-border'>
          {rows.map(row => {
            const initials =
              row.name
                .split(/\s+/)
                .map(part => part[0]?.toUpperCase() ?? '')
                .filter(Boolean)
                .slice(0, 2)
                .join('') || '?'
            return (
              <li
                key={row.id}
                className='flex flex-col items-start gap-1 py-2.5 sm:flex-row sm:items-center sm:justify-between sm:gap-4'
              >
                <div className='flex min-w-0 items-center gap-3'>
                  <span className='grid size-9 shrink-0 place-items-center rounded-full bg-accent text-xs font-semibold text-white'>
                    {initials}
                  </span>
                  <span className='min-w-0 text-sm font-medium break-words text-foreground sm:truncate'>
                    {row.name}
                  </span>
                </div>
                {row.role ? (
                  <span className='shrink-0 pl-12 text-xs text-muted-foreground sm:pl-0'>
                    {SUPPLIER_CONTACT_ROLE_LABELS[row.role]}
                  </span>
                ) : null}
              </li>
            )
          })}
        </ul>
      )}
    </ProfileSection>
  )
}
